import { call, put, takeLatest } from "redux-saga/effects"

import * as gql from "../../../common/graphql"
import { referenceComparator } from "../../common/Drilldown"
import { calculateDistanceOn } from "../../common/locationSupport"

import {
  HOME_FETCH_ALL_LG_BEGIN,
  HOME_FETCH_ALL_LG_DISMISS_ERROR,
  HOME_FETCH_ALL_LG_FAILURE,
  HOME_FETCH_ALL_LG_SUCCESS,
} from "./constants"

export const fetchAllLg = authToken => ({
  type: HOME_FETCH_ALL_LG_BEGIN,
  data: { authToken },
})

export const dismissFetchAllLgError = () => ({
  type: HOME_FETCH_ALL_LG_DISMISS_ERROR,
})

// worker Saga: will be fired on HOME_FETCH_ALL_LG_BEGIN actions
export function* doFetchAllLg({ data: { authToken } }) {
  const { data, graphqlErrors, networkError } = yield call(gqlFetchAllLg, authToken)

  if (data) {
    yield put({
      type: HOME_FETCH_ALL_LG_SUCCESS,
      data: { lhoData: data },
    })
  } else {
    yield put({
      type: HOME_FETCH_ALL_LG_FAILURE,
      data: { error: { graphqlErrors, networkError } },
    })
  }
}

export function gqlFetchAllLg(authToken) {
  return gql.post({
    authToken,
    queryName: "fetchAllLg",
    query: `query fetchAllLg {
      properties {
        reference
        description
        city
        zipCode
        longitude
        latitude
      }
    }`,
  })
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchFetchAllLg() {
  yield takeLatest(HOME_FETCH_ALL_LG_BEGIN, doFetchAllLg)
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case HOME_FETCH_ALL_LG_BEGIN:
      return {
        ...state,
        fetchAllLgPending: true,
        fetchAllLgError: null,
      }

    case HOME_FETCH_ALL_LG_SUCCESS:
      const lhoData = action.data.lhoData

      if (lhoData.properties && state.mapCenter) {
        lhoData.properties = calculateDistanceOn(state.mapCenter, lhoData.properties.sort(referenceComparator))
      }

      return {
        ...state,
        lhoData,
        fetchAllLgPending: false,
        fetchAllLgError: null,
      }

    case HOME_FETCH_ALL_LG_FAILURE:
      return {
        ...state,
        fetchAllLgPending: false,
        fetchAllLgError: action.data.error,
      }

    case HOME_FETCH_ALL_LG_DISMISS_ERROR:
      return {
        ...state,
        fetchAllLgError: null,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/fetchAllLg.js